
export const ptDocContainerSx = {
  width: '100%',
  height: '100%'
};

export const ptDocPaperSx = {
  border: '1px solid #DCDCDC',
  borderRadius: '10px',
  boxShadow: '0 2px 8px rgba(0,0,0,0.10)',
  overflow: 'hidden',
  backgroundColor: '#FFFFFF',
  p: 1.5,
  height: '100%'
};

export const ptDocGridSx = {
  display: 'flex',
  flex: '1 0 auto'
};